// Which credential store a "Passwort vergessen" run is talking to (#279).
//
// There are two, they are reached by different endpoints, and — as everywhere else on this branch — the app
// never guesses which. `/login` has two forms and each one carries its own link, so the kind is decided by the
// person who pressed it and travels as a query parameter from the forgot screen into the mail and back out of
// it on the reset screen.

/**
 * The two password-reset flows.
 *
 * - `legacy` — an **employee's** password (`/auth/user/resetpassword`), the flow that has always existed. It is
 *   company-scoped: the host alias picks the company, and the link carries one employee id.
 * - `account` — a **native** CheqMe account's password (`/auth/local/password/reset`, #279). Company-independent,
 *   because an `ExternalIdentity` belongs to no company.
 */
export type PasswordResetKind = 'legacy' | 'account';

/** The query-parameter value that selects the native flow. Absent (or anything else) means the legacy one. */
export const ACCOUNT_RESET_PARAM = 'account';

/**
 * The kind a URL asks for.
 *
 * **Unknown values fall back to `legacy` deliberately.** Every reset link minted before #279 carries no `kind`
 * at all, and those links must keep working for their full two-hour life across the deploy that adds this. The
 * fall-back is also the safe direction: the legacy endpoints resolve only employees, so a mistyped parameter can
 * never reach the native credential store by accident.
 */
export function passwordResetKindFrom(value: string | null | undefined): PasswordResetKind {
  return value === ACCOUNT_RESET_PARAM ? 'account' : 'legacy';
}
